import { useEffect, useState } from "react";
import { ConfigProvider, Input, Modal, Table, TableProps, theme as antdTheme } from "antd";
import { getAlunos } from "@/services/aluno";
import { errorHandler } from "@/utils/errorhandler";
import { filtrarAlunos } from "@/utils/filtroAlunos";
import { numeroDoAluno } from "@/utils/numeroAluno";

type AlunoModalProps = {
  open: boolean;
  /** Chamado com o aluno da linha clicada. */
  onSelect: (aluno: any) => void;
  onCancel: () => void;
};

/**
 * Pesquisa de aluno em modal: a mesma lista e o mesmo filtro da Consulta de
 * Alunos (Matrícula de Aluno), sem a coluna de Ação — aqui a linha inteira é o
 * botão de seleção.
 */
export default function AlunoModal({ open, onSelect, onCancel }: AlunoModalProps) {
  const [alunos, setAlunos] = useState<any[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [carregando, setCarregando] = useState(false);

  useEffect(() => {
    if (!open) return;

    const carregar = async () => {
      setCarregando(true);
      try {
        const response = await getAlunos();
        if (response.status === 200) {
          setAlunos(response.data || []);
        }
      } catch (error) {
        errorHandler(error);
      } finally {
        setCarregando(false);
      }
    };
    carregar();
  }, [open]);

  const columns: TableProps<any>["columns"] = [
    // Sequencial próprio do orçamento ou da matrícula, não o Id da tabela.
    { title: "Id", key: "id", render: (_, record) => numeroDoAluno(record) },
    { title: "Matricula", dataIndex: "matricula", key: "matricula" },
    { title: "Nome", dataIndex: "nome", key: "nome" },
    { title: "CPF", dataIndex: "cpf", key: "cpf" },
    { title: "Email", dataIndex: "email", key: "email" },
    { title: "Celular", dataIndex: "celular", key: "celular" },
    { title: "Unidade", dataIndex: "unidadeNome", key: "unidadeNome" },
    { title: "Turma", dataIndex: "turmaNome", key: "turmaNome" },
    { title: "Status", dataIndex: "statusNome", key: "statusNome" },
  ];

  return (
    <ConfigProvider theme={{ algorithm: [antdTheme.darkAlgorithm, antdTheme.compactAlgorithm] }}>
      <Modal
        title="Pesquisar aluno"
        open={open}
        onCancel={onCancel}
        footer={null}
        width={1000}
        destroyOnClose
      >
        <Input
          type="text"
          placeholder="Pesquisar por nome, CPF, matrícula, responsável ou dono do cheque"
          aria-label="Pesquisar aluno"
          className="w-96 mb-4"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <Table
          rowKey="id"
          size="small"
          loading={carregando}
          columns={columns}
          dataSource={filtrarAlunos(alunos, searchTerm)}
          pagination={{ pageSize: 8 }}
          locale={{ emptyText: "Nenhum aluno encontrado" }}
          onRow={(record) => ({
            onClick: () => onSelect(record),
            style: { cursor: "pointer" },
          })}
        />
      </Modal>
    </ConfigProvider>
  );
}
